import { render, staticRenderFns } from "./DefaultInput.vue?vue&type=template&id=59c04206"
import script from "./DefaultInput.vue?vue&type=script&lang=js"
export * from "./DefaultInput.vue?vue&type=script&lang=js"
import style0 from "./DefaultInput.vue?vue&type=style&index=0&id=59c04206&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports